import SyChips from "./sy-chips";


export default SyChips;
